import { useContext } from "react"
import { FeedContext, FeedContextType } from "../provider/FeedProvider"
import FeedTile from "./FeedTile";
import Pagination from "../../Common/Pagination/Pagination";

export type FeedPropsModel = {
  itemsPerRowSmall: number,
  itemsPerRowMedium: number,
  itemsPerRowLarge: number,
  defaultImage: string | null
}

export default function Feed(props: FeedPropsModel) {
  const { nodes, totalRecords, currentPage, pageSize, loadItems } = useContext(FeedContext) as FeedContextType;

  return (
    <>
      <div className={`grid-x grid-margin-x grid-margin-y small-up-${props.itemsPerRowSmall} medium-up-${props.itemsPerRowMedium} large-up-${props.itemsPerRowLarge}`}>
        { nodes.length > 0 && nodes.map(node => (
          <div key={`feed-${node.id}`} className="cell">
            <FeedTile node={node} defaultImage={props.defaultImage} />          
          </div>
        ))}
      </div>
      <Pagination totalRecords={totalRecords} currentPage={currentPage} pageSize={pageSize} onPageChange={loadItems} />
    </>
  )
}